/**
 * SimpleLayout is used in direct (prizes) payment mode and for error pages
 * This layout is a reduced-functionality layout - it *does not* rely on cart data for images/styling
 */
import { ThemeProvider, crTheme, LogoLinked } from '@comicrelief/component-library';

import Footer from '@/components/footer/Footer';
import SecureTextAndIcon from '@/components/common/SecureTextAndIcon';
import FundraisingRegulatorRow from '@/components/FundraisingRegulatorRow/FundraisingRegulatorRow';

import {
  Main, OuterContainer, InnerContainer, ContentWrapper,
  SmallAndMediumHeader, DesktopLogo, SecureTextAndIconDesktopWrapper
} from './SimpleLayout.style';

function SimpleLayout({ children }: React.PropsWithChildren) {
  return (
    <ThemeProvider theme={crTheme}>

      <Main role="main" id="main-content">

        <OuterContainer>

          <DesktopLogo>
            <LogoLinked url="https://www.comicrelief.com" animateRotate />
          </DesktopLogo>

          <InnerContainer>

            <SmallAndMediumHeader>
              <LogoLinked url="https://www.comicrelief.com" animateRotate />
              <SecureTextAndIcon $mobile />
            </SmallAndMediumHeader>

            <ContentWrapper>
              {children}
            </ContentWrapper>

          </InnerContainer>

          <SecureTextAndIconDesktopWrapper>
            <SecureTextAndIcon />
          </SecureTextAndIconDesktopWrapper>

        </OuterContainer>

        <FundraisingRegulatorRow />

      </Main>

      <Footer />

    </ThemeProvider>
  );
}

export default SimpleLayout;
